__turbopack_context__.v({
  "className": "proximanova_9854cf52-module__KBkMzq__className",
  "variable": "proximanova_9854cf52-module__KBkMzq__variable",
});
